module.exports = __webpack_public_path__ + "ci_vender_whatap.20aa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vender_whatap.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vender_whatap.svg
// module chunks = main